export const PAGES = {
  story: {
    title: "Built by a caregiver. Not a company. | Handoff",
    description: "The context the demo alone can't carry: why respite fails, and what Handoff does about it.",
    image: "/img/og-story.jpg",
  },
  film: {
    title: "The film | Handoff",
    description: "Where Handoff started: the brief that lets someone you trust step in.",
    image: "/img/og-film.jpg",
  },
};
